import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { registerServiceWorker } from './lib/sw';
import { installConsoleHooks } from './components/DebugConsole';
import { AuthGate } from './components/AuthGate';
import { InstallGate } from './components/InstallGate';
import { OnboardingPermissions } from './components/OnboardingPermissions';
import { migrateLegacyStaticRegion } from './lib/useUiSettings';

// Debug-Konsole-Hooks GANZ FRÜH installieren (vor allem anderen), damit
// auch Logs von SW-Registrierung / Manifest-Fetch / Map-Init erfasst werden.
// Das Overlay selbst wird nur gemountet wenn ?debug=1 oder Flag gesetzt ist —
// die Hooks laufen aber immer. Das ist billig (nur 4 console-Methoden gewrapped)
// und kostet nichts im Normalbetrieb.
installConsoleHooks();

// WICHTIG: MapLibre-CSS zuerst, damit Map-Controls (+/−, Kompass, Crosshair) sichtbar sind.
// Der JS-Import umgeht das CSS-@import-Order-Problem mit Tailwind.
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/index.css';
import { applyInitialTheme } from './lib/theme';

// Wave 14de: Theme synchron VOR React-Render anwenden — sonst blitzt
// kurz das default-dark auf bevor das Light-Theme greift (= FOUC).
applyInitialTheme();

// Wave 14ed: Alt-Installationen haben '3pbr' (die frueher fest eingebaute
// 3-Peaks-Route) als aktive Region in localStorage stehen — gesetzt vom
// alten DEFAULT_REGION, nicht vom User. Die Region gibt es nicht mehr.
// Einmal wegraeumen, SYNCHRON vor dem ersten Render, damit Profil, Karte
// und Region-Banner gar nicht erst mit einer toten Region hochkommen.
migrateLegacyStaticRegion();

// In Dev-Mode Hinweis auf Admin-UI
if (import.meta.env.DEV) {
  console.info(
    '%c[All Day Turbo] Admin-UI läuft separat auf http://localhost:5174',
    'color:#0d9488;font-weight:bold',
  );
}

// Service Worker registrieren — ohne das sind die Workbox-Runtime-Caches
// (PMTiles / Trails / Manifest) nie aktiv und die App ist bei wackligem Netz
// komplett am Netz hängen. SICHER vor React-Mount aufrufen damit der SW
// frühzeitig die Navigation-Requests abfängt.
registerServiceWorker();

// Wave 14av: Persistent-Storage anfordern.
//
// iOS Safari + Chrome evictieren IndexedDB/Cache Storage für Websites unter
// Speicher-Druck — für eine PWA ist das eine Katastrophe: über Nacht können
// gecachte SRTM-Höhensamples, POI-Daten und offline-Trails verschwinden.
// `navigator.storage.persist()` bittet den Browser die Daten als persistent
// zu markieren. Bei PWAs die zum Homescreen hinzugefügt sind wird das
// automatisch genehmigt; im normalen Safari-Tab kommt meist ein non-promptes
// Grant oder Deny je nach Engagement-Heuristik. Failure-Modus ist stumm:
// wenn's nicht geht laufen wir halt weiter wie vorher.
void (async () => {
  if ('storage' in navigator && navigator.storage.persist) {
    try {
      const already = await navigator.storage.persisted?.();
      if (already) return;
      const granted = await navigator.storage.persist();
      console.info(
        `[storage] persistent=${granted} (once granted, IDB survives iOS memory pressure)`,
      );
    } catch (err) {
      console.info('[storage] persist() failed', err);
    }
  }
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Wave 14ca-fix2: Reihenfolge wieder umgedreht. InstallGate sitzt
          jetzt GANZ AUSSEN — beim allerersten Öffnen im Mobile-Browser
          sieht der User KEIN Login-Formular sondern eine kurze Anleitung,
          wie er die PWA aufs Homescreen legt. Erst NACH dem Tap "Open
          from home screen" (= App startet im Standalone-Mode) bekommt er
          den Login-Screen. Grund: Friend-Test hat gezeigt, dass User die
          Add-to-Home-Screen-Anleitung später vergessen, wenn sie sich
          erst im Safari einloggen. Außerdem ist die iOS-Falle (Safari
          ↔ PWA-Storage isoliert, doppeltes Einloggen) damit weg — der
          User loggt sich genau dort ein, wo er später bleibt: in der
          installierten PWA.

          Reihenfolge: InstallGate (mobile, non-standalone)
                     → AuthGate (login)
                     → FirstLaunchGate (nur Region-Wahl, kein Download)
                     → App. */}
      <InstallGate>
        <AuthGate>
          {/* Wave 14ca-fix8: OnboardingPermissions sitzt direkt nach
              AuthGate, vor FirstLaunchGate. Heißt: User loggt sich
              ein → kombinierter Permission-Screen (Push/Location/
              Compass) → Map-Download. So sind alle Berechtigungen
              vor dem ersten echten App-Use geklärt; kein piecemeal-
              Prompting später. */}
          <OnboardingPermissions>
            {/* Wave 14ed: FirstLaunchGate ist RAUS. Auch der Region-Picker
                war fuer einen neuen User Zwang — und die einzige Region,
                die er zu sehen bekam, war die fest eingebaute 3-Peaks-Route.
                Jetzt: einloggen, Permissions, fertig. Keine Region, kein
                Download, kein Screen dazwischen. Der User baut sich unter
                Navi · Korridor irgendwann seinen eigenen Korridor; ab dann
                taucht der als Region auf. */}
            <App />
          </OnboardingPermissions>
        </AuthGate>
      </InstallGate>
    </BrowserRouter>
  </React.StrictMode>,
);
